export enum EventMethod {
  img = 1,
  js = 2
}
